import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { Divider, Box, TablePagination } from "@mui/material";

import { resolveSrc } from "../../../api/endpoints";
import ContentCard from "../../../components/contentcard/ContentCard";
import ListViewFile from "./ListViewFile";
import DialogBoxEditScreen from "./EditScreen/DialogBoxEditScreen"
import DialogBoxTwitchPlaylist from "../Widgets/DialogBoxTwitchPlaylist";
import { DialogBoxLiveYoutube, DialogBoxLiveTwitch, DialogBoxLiveVimeo } from "../Widgets/DialogBoxLive";
import DialogBoxYoutubePlaylist from "../Widgets/DialogBoxYoutubePlaylist";
import DialogBoxYt from "../Widgets/DialogBoxYt";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { editWidget } from "src/redux/actions/Content";
import DialogBoxWeather from "../Widgets/DialogBoxWeather";
import DialogBoxVimeo from "../Widgets/DialogBoxVimeo";
import DialogBoxWebSite from "../Widgets/DialogBoxWebSite";
import DialogBoxEmbed from "../Widgets/DialogBoxEmbed";
import DialogBoxScrollingStrip from "../Widgets/DialogBoxScrollingStrip";
import DialogBoxCanva from "../Widgets/DialogBoxCanva";
import DialogBoxPostermywall from "../Widgets/DialogBoxPostermywall";
import DialogPMWEditSync from "../Widgets/DialogPMWEditSync";

function All({
  setRefreshData,
  content,
  onAddPlaylist,
  onPushScreen,
  onDelete,
  onMove,
  onPreview,
  view,
  onCheckedSingleContent,
  onUncheckedSingleContent,
  onUncheckedContent,
  handleSelectAll,
  handleOpenFoldersDataDialog,
  checkFilesPlaylists,
  refreshCurrentFiles,
  setCurrentContentPreview
}) {
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const { t } = useTranslation();

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(50);
  const [openSplitScreenDialog, setOpenSplitScreenDialog] = React.useState(false)
  const [openTwitchDialog, setOpenTwitchDialog] = React.useState(false)
  const [openYoutubeDialog, setOpenYoutubeDialog] = React.useState(false)
  const [selectedContentId, setSelectedContentId] = React.useState(null)
  const [savedZones, setSavedZones] = React.useState({})
  const [openYTmodal, setOpenYTmodal] = React.useState({open: false, widgetData: null})
  const [openWeathermodal, setOpenWeathermodal] = React.useState({open: false, widgetData: null})
  const [openVimeoModal, setOpenVimeoModal] = React.useState({open: false, widgetData: null})
  const [openWebsiteModal, setOpenWebsiteModal] = React.useState({open: false, widgetData: null})
  const [openEmbedModal, setOpenEmbedModal] = React.useState({open: false, widgetData: null})
  const [openScrollstripModal, setOpenScrollstripModal] = React.useState({open: false, widgetData: null})
  const [openCanvaModal, setOpenCanvaModal] = React.useState({open: false, widgetData: null})
  const [openPMWModal, setOpenPMWModal] = React.useState({open: false, widgetData: null})
  const [openLiveModal, setOpenLiveModal] = React.useState({open: false, widgetData: null})
  const [openPMWEditSyncModal, setOpenPMWEditSyncModal] = React.useState({open: false, widgetData: null})

  const ssId = React.useRef(null)
  const sz = React.useRef(null)
  const twitch = React.useRef(null)
  const youtube = React.useRef(null)

  const contentToView = [...content].slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const dispatch = useDispatch()

  useEffect(() => {
    if (handleSelectAll) {
      contentToView.forEach((c) => onCheckedSingleContent(c.id));
    }
  }, [handleSelectAll]);

  useEffect(() => {
    const hasYoutubeContent = contentToView.some(
      (item) => item?.widget?.widgetCat === 'youtube' || item?.widget?.widgetCat === 'yt_playlist',
    );

    if (!hasYoutubeContent || !refreshCurrentFiles) {
      return undefined;
    }

    const intervalId = setInterval(() => {
      refreshCurrentFiles();
    }, 5000);

    return () => clearInterval(intervalId);
  }, [contentToView, refreshCurrentFiles]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    onUncheckedContent();
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    onUncheckedContent();
  };

  const handleSeeSplitScreen = (contentObject) => {
    console.log("see split", contentObject);
    if (contentObject && contentObject.widget && contentObject.widget.widgetCat === "split_screen") {
      setSelectedContentId(contentObject.id);
      setSavedZones(contentObject.widget);
      sz.current = contentObject.widget;
      setOpenSplitScreenDialog(true);
    } else {
      console.error("Invalid split screen data");
    }
  };

  const handleSeeTwitchDialog = (contentObject) =>{
    console.log("see twitch", contentObject)
    twitch.current = contentObject
    setOpenTwitchDialog(true)
  }

  const handleSeeYoutubeDialog = (contentObject) =>{
    console.log("see youtube", contentObject)
    youtube.current = contentObject
    setOpenYoutubeDialog(true)
  }

  const handleTwitchPreview = (contentObject) => {
    const parts = contentObject?.widget?.url?.split('/');
    const channel = parts[parts.length - 1];
    const chat = contentObject?.widget?.chat ? 'true' : 'false';
    let theme = 'light';
    if (contentObject?.widget?.theme === 'Dark Theme') {
      theme = 'dark';
    }
  
    window.open(
      `${baseUrl}/twitchtv?chat=${chat}&channel=${channel}&theme=${theme}`,
      '_blank'
    );
  };

    const handleEditYTWidget = async (widgetObj) => {
      const reqOb = {
        type: 'yt',
        id: openYTmodal.widgetData.id,
        data: {
          url: widgetObj.url,
          html: widgetObj.html
        }
      }
      dispatch(editWidget(reqOb));
    };

    const handleEditWeatherWidget = async (widgetObj) => {
      const reqOb = {
        type: 'weather',
        id: openWeathermodal.widgetData.id,
        data: widgetObj.weather
      }
      dispatch(editWidget(reqOb));
    }
  
    const handleEditVimeoWidget = async (widgetObj) => {
      const reqOb = {
        type: 'vimeo',
        id: openVimeoModal.widgetData.id,
        data: {
          url: widgetObj.url,
          html: widgetObj.html
        }
      }
      dispatch(editWidget(reqOb));
    };

    const handleEditWebsiteWidget = async (widgetObj) => {
      const reqOb = {
        type: 'website',
        id: openWebsiteModal.widgetData.id,
        data: {
          url: widgetObj.url,
          intervalValue: widgetObj.intervalValue
        }
      }
      dispatch(editWidget(reqOb));
    };
    
    const handleEditEmbedWidget = async (widgetObj) => {
      const reqOb = {
        type: 'embed',
        id: openEmbedModal.widgetData.id,
        data: {
          html: widgetObj.html
        }
      }
      dispatch(editWidget(reqOb));
    };

    const handleEditScrollstripWidget = async (widgetObj) => {
      const reqOb = {
        type: 'scrollingstrip',
        id: openScrollstripModal.widgetData.id,
        data: {
          html: widgetObj.html,
          url: widgetObj.url,
          scrollingstrip: widgetObj.scrollingstrip
        }
      }
      dispatch(editWidget(reqOb));
    }

    const handleEditCanvaWidget = async (widgetObj) => {
      const reqOb = {
        type: 'canva',
        id: openCanvaModal.widgetData.id,
        data: {
          html: widgetObj.html,
          url: widgetObj.url,
          newEmbed: widgetObj.newEmbed,
          newLink: widgetObj.newLink,
        }
      }
      return dispatch(editWidget(reqOb));
    }

    const handleEditPMWWidget = async (widgetObj) => {
      if (!openPMWEditSyncModal?.widgetData?.id) {
        return null;
      }

      const reqOb = {
        type: 'pmw',
        id: openPMWEditSyncModal.widgetData.id,
        data: {
          url: widgetObj.url
        }
      }
      return dispatch(editWidget(reqOb));
    }

  const handleWidgetEdit = (contentObj) => {
    switch(contentObj?.widget?.widgetCat){
      case 'live_youtube':
      case 'live_twitch':
      case 'live_vimeo':
        setOpenLiveModal({open: true, widgetData: contentObj})
        break
      case 'youtube':
        setOpenYTmodal({open: true, widgetData: contentObj})
        break
      case 'weather':
        setOpenWeathermodal({open: true, widgetData: contentObj})
        break
      case 'vimeo':
        setOpenVimeoModal({open: true, widgetData: contentObj})
        break
      case 'website':
        setOpenWebsiteModal({open: true, widgetData: contentObj})
        break
      case 'embed':
        setOpenEmbedModal({open: true, widgetData: contentObj})
        break
      case 'scrollingstrip':
        setOpenScrollstripModal({open: true, widgetData: contentObj})
        break
      case 'canva':
        setOpenCanvaModal({open: true, widgetData: contentObj})
        break
      case 'postermywall':
        window.open(
          process.env.REACT_APP_PMW_PROFILE_URL || "https://www.postermywall.com/index.php/authenticate/showlogin/?redirect=https%3A%2F%2Fwww.postermywall.com%2Findex.php",
          "_blank",
        );
        setOpenPMWEditSyncModal({open: true, widgetData: contentObj})
        break
    }
  }

  return (
    <>
      <DialogBoxEditScreen 
        setRefreshData={setRefreshData} 
        id={selectedContentId} 
        isOpen={openSplitScreenDialog} 
        onClose={setOpenSplitScreenDialog} 
        orientation={sz.current?.orientation || "portrait"} 
        rectanglesUnfolding={sz.current} 
        isNew={false}
      />
      <DialogBoxTwitchPlaylist  object={twitch.current} isNew={false} isOpen={openTwitchDialog} onClose={setOpenTwitchDialog} />
      {[
        ['live_youtube', DialogBoxLiveYoutube],
        ['live_twitch', DialogBoxLiveTwitch],
        ['live_vimeo', DialogBoxLiveVimeo],
      ].map(([cat, LiveDialog]) => (
        <LiveDialog
          key={cat}
          isOpen={openLiveModal.open && openLiveModal.widgetData?.widget?.widgetCat === cat}
          onClose={() => setOpenLiveModal({...openLiveModal, open: false})}
          isIcon={openLiveModal.widgetData?.widget?.widgetIcon}
          startupData={openLiveModal.widgetData}
        />
      ))}
      <DialogBoxYoutubePlaylist object={youtube.current} isNew={false} isOpen={openYoutubeDialog} onClose={setOpenYoutubeDialog} isIcon={"/images/yt_app.png"}/>
      <DialogBoxYt isOpen={openYTmodal.open} onClose={() => setOpenYTmodal({...openYTmodal, open: false})} isIcon={'/images/youtubeIcon.png'} onAddWidget={handleEditYTWidget} startupData={openYTmodal.widgetData} onTakeData={() => {}} />
      <DialogBoxWeather isOpen={openWeathermodal.open} onClose={() => setOpenWeathermodal({...openWeathermodal, open: false})} isIcon={'/images/weather-widget.png'} onAddWidget={handleEditWeatherWidget} startupData={openWeathermodal.widgetData}/>
      <DialogBoxVimeo isOpen={openVimeoModal.open} onClose={() => setOpenVimeoModal({...openVimeoModal, open: false})} isIcon={'/images/vimeoIcon.png'} onAddWidget={handleEditVimeoWidget} startupData={openVimeoModal.widgetData} onTakeData={() => {}} />
      <DialogBoxWebSite isOpen={openWebsiteModal.open} onClose={() => setOpenWebsiteModal({...openWebsiteModal, open: false})} isIcon={'/images/websiteIcon2.png'} onAddWidget={handleEditWebsiteWidget} startupData={openWebsiteModal.widgetData} onTakeData={() => {}} />
      <DialogBoxEmbed isOpen={openEmbedModal.open} onClose={() => setOpenEmbedModal({...openEmbedModal, open: false})} isIcon={'/images/embedIcon.png'} onAddWidget={handleEditEmbedWidget} startupData={openEmbedModal.widgetData} onTakeData={() => {}} />
      <DialogBoxScrollingStrip isOpen={openScrollstripModal.open} onClose={() => setOpenScrollstripModal({...openScrollstripModal, open: false})} isIcon={'/images/scrollingStripIcon.png'} onAddWidget={handleEditScrollstripWidget} startupData={openScrollstripModal.widgetData} onTakeData={() => {}} />
      <DialogBoxCanva isOpen={openCanvaModal.open} onClose={() => setOpenCanvaModal({...openCanvaModal, open: false})} isIcon={'/images/canvaLogo.svg'} onAddWidget={handleEditCanvaWidget} onAddContent={() => {}} startupData={openCanvaModal.widgetData} />
      <DialogBoxPostermywall isOpen={openPMWModal.open} onClose={() => setOpenPMWModal({...openPMWModal, open: false})} isIcon={'/images/postermywallLogo.png'} onAddContent={() => {}} onAddWidget={handleEditPMWWidget} startupData={openPMWModal.widgetData} />
      <DialogPMWEditSync
        isOpen={openPMWEditSyncModal.open}
        onClose={() => setOpenPMWEditSyncModal({ open: false, widgetData: null })}
        startupData={openPMWEditSyncModal.widgetData}
        onApplyWidgetUrl={handleEditPMWWidget}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: "16px",
          flexWrap: "wrap",
          margin: "10px 0",
        }}>
        {view
          ? contentToView.map((data, index) => {
            // MERGE
            // if (data?.type == "split_screen"){
            //   return (
            //     // <div>TUTAJ SPLIT SCREEN</div>
            //     <ContentCard
            //       setRefreshData={setRefreshData}
            //       key={++index}
            //       url={`${baseImg}/${data.url}`}
            if (data?.isActive || data?.type === "split_screen") {
              return (
                <ContentCard
                  setRefreshData={setRefreshData}
                  key={data.id || index}
                  url={resolveSrc(data.url)}
                  type={data.type}
                  name={data.name}
                  checked={data?.checked}
                  onCheckedSingleContent={onCheckedSingleContent}
                  onUncheckedSingleContent={onUncheckedSingleContent}
                  contentObject={data}
                  onAddPlaylist={onAddPlaylist}
                  onPushScreen={onPushScreen}
                  onDelete={onDelete}
                  onMove={onMove}
                  onPreview={onPreview}
                  createdAt={data.createdAt}
                  handleSeeSplitScreen={handleSeeSplitScreen}
                  handleTwitchPreview={handleTwitchPreview}
                  handleSeeTwitchDialog={handleSeeTwitchDialog}
                  handleSeeYoutubeDialog={handleSeeYoutubeDialog}
                  onEditWidget={handleWidgetEdit}
                />
              );
            }
            else{
              if (data?.isActive) {
                return (
                  <ContentCard
                    key={++index}
                    url={resolveSrc(data.url)}
                    type={data.type}
                    name={data.name}
                    checked={data?.checked}
                    onCheckedSingleContent={onCheckedSingleContent}
                    onUncheckedSingleContent={onUncheckedSingleContent}
                    contentObject={data}
                    onAddPlaylist={onAddPlaylist}
                    onPushScreen={onPushScreen}
                    onDelete={onDelete}
                    onMove={onMove}
                    onPreview={onPreview}
                    createdAt={data.createdAt}
                    handleSeeSplitScreen={handleSeeSplitScreen}
                    handleTwitchPreview={handleTwitchPreview}
                    handleSeeTwitchDialog={handleSeeTwitchDialog}
                    handleSeeYoutubeDialog={handleSeeYoutubeDialog}
                    onEditWidget={handleWidgetEdit}
                  />
                );
              }
            }

            })
          : contentToView.map((data, index) => {
            if (data?.isActive || (data?.type == "split_screen" && data?.name && data?.createdAt)) {
              return (
                <ListViewFile
                  key={++index}
                  url={resolveSrc(data.url)}
                  type={data.type}
                  name={data.name || "undefined"}
                  checked={data?.checked}
                  onCheckedSingleContent={onCheckedSingleContent}
                  onUncheckedSingleContent={onUncheckedSingleContent}
                  contentObject={data}
                  onAddPlaylist={onAddPlaylist}
                  onPushScreen={onPushScreen}
                  onDelete={onDelete}
                  onMove={onMove}
                  onPreview={onPreview}
                  createdAt={data.createdAt}
                  handleSeeSplitScreen={handleSeeSplitScreen}
                  handleTwitchPreview={handleTwitchPreview}
                  handleSeeTwitchDialog={handleSeeTwitchDialog}
                  handleSeeYoutubeDialog={handleSeeYoutubeDialog}
                  folders={data?.foldersData}
                  handleOpenFoldersDataDialog={handleOpenFoldersDataDialog}
                  checkFilesPlaylists={checkFilesPlaylists}
                  onEditWidget={handleWidgetEdit}
                  setCurrentContentPreview={setCurrentContentPreview}
                />
              );
            }
            else{
              if (data?.isActive) {
                return (
                  <ListViewFile
                    key={++index}
                    url={resolveSrc(data.url)}
                    type={data.type}
                    name={data.name}
                    checked={data?.checked}
                    onCheckedSingleContent={onCheckedSingleContent}
                    onUncheckedSingleContent={onUncheckedSingleContent}
                    contentObject={data}
                    onAddPlaylist={onAddPlaylist}
                    onPushScreen={onPushScreen}
                    onDelete={onDelete}
                    onMove={onMove}
                    onPreview={onPreview}
                    createdAt={data.createdAt}
                    handleTwitchPreview={handleTwitchPreview}
                    handleSeeTwitchDialog={handleSeeTwitchDialog}
                    handleSeeYoutubeDialog={handleSeeYoutubeDialog}
                    folders={data?.foldersData}
                    handleOpenFoldersDataDialog={handleOpenFoldersDataDialog}
                    checkFilesPlaylists={checkFilesPlaylists}
                    onEditWidget={handleWidgetEdit}
                    setCurrentContentPreview={setCurrentContentPreview}
                  />
                );
              }
            }
            })}
      </Box>
      <Divider />

      {/* <TablePagination
        rowsPerPageOptions={[5, 10, 15]}
        component="div"
        count={content.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelRowsPerPage={t("views.all.rowsQty")}
      /> */}
    </>
  );
}

export default All;
